module.exports = __webpack_public_path__ + "static/fish-curve-3b0929abf28f143e8c25e8fda9e7c8e4.ogv";